import isProd from './isProd';

const PROD_URL = "https://iot-core.traxsmart.in/v1"
const STAGIN_URL = "https://iot-core-staging.traxsmart.in/v1";
// const LOCAL_TESTING_URL = 'http://localhost:5000/v1';


// const isDev = true;
//
const BASE_URL = PROD_URL;
// const BASE_URL = LOCAL_TESTING_URL;
// const BASE_URL = 'https://test-panvel-backend.onrender.com/v1';
// const BASE_URL = 'https://vltd-api-staging.traxsmart.in/v1';
// const BASE_URL = 'https://ascl-ps.traxsmart.in/api';

// AUTH URLS
export const AUTH_URL = `${BASE_URL}/auth`;
export const LOGIN_URL = `${AUTH_URL}/login`;
export const REFRESH_TOKEN_URL = `${AUTH_URL}/refresh-tokens`;
export const REGISTER_URL = `${AUTH_URL}/register`;
export const LOGOUT_URL = `${AUTH_URL}/logout`;
export const GET_LOGGED_IN_URL = `${AUTH_URL}/logged-in-user`;
export const FORGET_PASSWORD_URL = `${AUTH_URL}/forgot-password`;
export const RESET_PASSWORD_URL = `${AUTH_URL}/reset-password`;
export const CHANGE_PASSWORD_URL = `${AUTH_URL}/change-password`;

// APP URLS

// user urls
export const USER_URL = `${BASE_URL}/users`;
export const ROLE_URL = `${BASE_URL}/roles`;
export const ORGANISATION_URL = `${BASE_URL}/organisation`;
export const WAREHOUSE_URL = `${BASE_URL}/warehouse`;
export const DEPARTMENT_URL = `${BASE_URL}/departments`;
export const TAG_URL = `${BASE_URL}/tag`;

export const FIRMWARE_URL = `${BASE_URL}/firmware`;
export const FIRMWARE_VERSION_URL = `${BASE_URL}/firmware-version`;
export const FIRMWARE_LIFECYCLE_URL = `${BASE_URL}/firmware-timeline`;
export const PRODUCT_URL = `${BASE_URL}/product`;
export const ITEM_GROUP_URL = `${BASE_URL}/item-group`;
// FILE UPLOAD
export const FILE_UPLOAD_URL = `${BASE_URL}/file`;
// org association
export const ORGANISATION_ASSOCIATION = `${BASE_URL}/organisation-association`;

export const ANALYTICS_URL = `${BASE_URL}/analytics`;
export const IOT_URL = `${BASE_URL}/iot`;

export const OTA_BATCH_URL = `${BASE_URL}/ota-batch`;
export const OTA_JOB_URL = `${BASE_URL}/ota-job`;
export const PDI_URL = `${BASE_URL}/pdi`;
export const PDI_LOG_URL = `${BASE_URL}/pdi-log`;
export const ORDER_URL = `${BASE_URL}/order`;
export const DISPATCH_GROUP_URL = `${BASE_URL}/dispatch-group`;
export const DISPATCH_LOG_URL = `${BASE_URL}/dispatch-log`;
export const BULK_SERVICE_URL = `${BASE_URL}/service-batch`;
export const SERVICE_LOG_URL = `${BASE_URL}/service-log`;
export const ORDER_FIRMWARE_VARIANT_URL = `${BASE_URL}/order-firmware-variant`;
export const ITEM_URL = `${BASE_URL}/item`;
export const BOM_URL = `${BASE_URL}/bom`;
export const PROCESS_URL = `${BASE_URL}/process`;
export const PROCESS_LOG_URL = `${BASE_URL}/process-log`;
export const STATIONS_URL = `${BASE_URL}/stations`;
export const STATION_URL = STATIONS_URL;
export const STATIONAL_SESSION_URL = `${BASE_URL}/stational-sessions`;

export const RETURN_URL = `${BASE_URL}/return-batch`;
export const PRINT_STICKER_URL = `${BASE_URL}/print-sticker`;
export const QR_CODE_URL = `${BASE_URL}/qrcodes`;
export const INVENTORY_CACHING_URL = `${BASE_URL}/inventory-caching`;
export const MATERIAL_PLANNING_URL = `${BASE_URL}/material-planning`;

// Device issue tickets — replace paths when backend is ready
export const DEVICE_ISSUE_URL = `${BASE_URL}/device-issue`;
export const DEVICE_ISSUE_ISSUES_URL = `${DEVICE_ISSUE_URL}/issues`;

export const DEVICE_ALERT_URL = `${BASE_URL}/device-alert`;
export const ALERTS_API_URL = `${BASE_URL}/alerts`;

export const REPORT_URL = `${BASE_URL}/report`;

export const EXT_ADDRESS_URL = `https://location.traxsmart.in/api/v1/location`;
export const ROADMAP_TILE_URL = `https://location.traxsmart.in/api/v1/location/tile/{x}/{y}/{z}/roadmap`;
export const SATTELITE_TILE_URL = `https://location.traxsmart.in/api/v1/location/tile/{x}/{y}/{z}/satellite`;